// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"613":"563ece5b","621":"381a9715","743":"a6bf4f9a"}[chunkId] + ".chunk.js";
};